"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "What medical services do you provide in Cyprus?",
  answer: "We offer a wide range of specialized treatments across our clinics in Limassol and Nicosia, including diagnostic screenings, personalized therapy plans, and advanced surgical consultations designed for patient-centered care."
}, {
  question: "How can I book an appointment?",
  answer: "You can book an appointment through our online portal, by calling our Nicosia or Limassol offices directly, or by filling out the contact form. We strive to accommodate urgent requests within 24-48 hours."
}, {
  question: "Do you accept local health insurance or Gesy?",
  answer: "Yes, we work with most major insurance providers in Cyprus and the Gesy system for eligible services. Please contact our administration team to verify your specific coverage and any required documentation."
}, {
  question: "Where are your clinics located?",
  answer: "Our primary facilities are centrally located in Limassol and Nicosia, featuring modern medical equipment and comfortable environments designed to provide accessible healthcare to residents across the island."
}, {
  question: "What should I bring to my first visit?",
  answer: "Please bring your ID card, any previous medical records or recent test results, and a list of current medications. This comprehensive information helps our specialists provide the most accurate assessment from the start."
}, {
  question: "Are emergency services available at your facilities?",
  answer: "While we provide comprehensive specialist care and scheduled treatments, for immediate life-threatening emergencies, please call 112 or visit the nearest general hospital emergency department in your city."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="1908" id="faq" className="bg-background py-24 relative overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-sans text-foreground mb-4 tracking-tight">
            Common Health Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Find answers to frequently asked questions about our treatments,
            appointments, and medical services in Cyprus.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0 px-2 data-[state=open]:bg-card transition-colors duration-300" data-index={i}>
              <AccordionTrigger className="font-sans font-medium text-lg text-foreground hover:text-accent hover:no-underline transition-colors duration-300 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] py-5 text-left">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}